import React from "react";
import "./Styles/main.scss";
import Routes from "./routes";
import MainProvider from "./Contexts/MainProvider";
import GlobalAlerts from "./Components/GlobalAlerts";

function App() {
    return (
        <MainProvider>
            <GlobalAlerts />
            <Routes />
        </MainProvider>
    );
}

export default App;
